module.exports = __webpack_public_path__ + "static/Sync service.drawio-496b90e93b8282b89c395619dca7dabc.png";